export const COLOR_LIST = [
  '#000000', '#a63d3c', '#a6431d', '#ad9533', '#42aa37', '#057485', '#004d80', '#33228c', '#7b2762',
  '#2c3136', '#d95959', '#ce673d', '#dabe2a', '#59bb4f', '#24a6bc', '#0076ba', '#523ebb', '#95277e',
  '#626973', '#ff768c', '#ff9771', '#e9de4c', '#6fdd04', '#02cfcf', '#01a2ff', '#7a64df', '#ac5097',
  '#ffffff', '#fbdbe0', '#fed89c', '#f6f29c', '#cafcc5', '#b4fbfb', '#b2defd', '#c4bbf4', '#ebacdd'
]

export const ALIGN_LIST = [
  {
    icon: require('../assets/img/text_right_white@2x.png'),
    activeIcon: require('../assets/img/text_right_purple@2x.png'),
    value: 'right'
  },
  {
    icon: require('../assets/img/text_center@2x.png'),
    activeIcon: require('../assets/img/text_center_purple@2x.png'),
    value: 'center'
  },
  {
    icon: require('../assets/img/text_left_white@2x.png'),
    activeIcon: require('../assets/img/text_left_purple@2x.png'),
    value: 'left'
  }
]
